import { Person } from "fhir/r5";
import { GetPerson } from "./GetPerson";
import { PutPerson } from "./PutPerson";

const TERM_REFUSED_URL = "https://fluxmed.com.br/termRefused";

/**
 * Aplica aceite de termos no Person existente sem apagar
 * managingOrganization, telecom, gender e demais campos já gravados.
 */
function applyTermsAcceptanceToPerson(
  person: Person,
  updates: { active?: boolean; termRefused?: boolean },
): Person {
  const extension = [...(person.extension || [])];
  if (updates.termRefused !== undefined) {
    const nextExtension = {
      url: TERM_REFUSED_URL,
      valueBoolean: updates.termRefused,
    };
    const index = extension.findIndex((item) =>
      item.url?.includes("termRefused"),
    );
    if (index >= 0) extension[index] = nextExtension;
    else extension.push(nextExtension);
  }

  return {
    ...person,
    active: updates.active ?? person.active,
    extension,
  };
}

/**
 * Atualiza todos os Person do CPF ao aceitar os termos.
 * Se nenhum for encontrado, cai no PUT canônico (primeiro cadastro).
 */
export async function PutPersonTermsAcceptance(objData: {
  identifier: string;
  name?: string;
  birthDate?: string;
  active?: boolean;
  termRefused?: boolean;
}) {
  const result = await GetPerson({ identifier: objData.identifier });
  const persons = result?.persons ?? [];

  if (persons.length === 0) {
    return PutPerson(objData);
  }

  await Promise.all(
    persons.map((person) =>
      PutPerson({
        identifier: objData.identifier,
        personId: person.id,
        existingResource: applyTermsAcceptanceToPerson(person, {
          active: objData.active,
          termRefused: objData.termRefused,
        }),
      }),
    ),
  );
}
